import React, { PureComponent } from "react";
import Slider from "react-slick";

import { Icon, Button } from '../../components';

import style from "./ProjectsBanner.module.scss";

class ProjectsBanner extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      slider: 0
    }
  }

  prevSlide = () => {
    if (this.slider) this.slider.slickPrev();
  }

  nextSlide = () => {
    if (this.slider) this.slider.slickNext();
  }

  render() {
    const {
      title,
      caption,
      data,
      projects
    } = this.props;

    let banner = (data && Array.isArray(data.banner)) ? data.banner : []
    let header = title
    let description = caption
    let linkButton = 'Latest Project'
    let link = '#'

    if (projects && projects.projects) {
      const pdata = projects.projects
      header = pdata.title || header
      description = pdata.description || description
      linkButton = pdata.linkButton || linkButton
      link = pdata.link || link
      if (projects.projects_slider && projects.projects_slider.length) {
        banner = projects.projects_slider
      }
    }

    const len = banner.length
    if (!len) return null

    const settings = {
      adaptiveHeight: true,
      arrows: false,
      dots: false,
      infinite: len > 1,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      afterChange: (next) => this.setState({ slider: next })
    }

    return (
      <div className={style.container}>
        <div className={style.container__banner}>
          <Slider key={`projects-banner-${len}`} ref={c => (this.slider = c)} {...settings}>
            {banner.map((_el, i) => (
              <div className={style.banner} key={`banner-${i}`}>
                <img src={_el.image} className={style.banner__image} alt="" />
              </div>
            ))}
          </Slider>
        </div>
        <div className={style.container__inner}>
          <div className={style.arrow__container}>
            <div className={`${style.arrow} ${style[`arrow--left`]}`} onClick={this.prevSlide}>
              <Icon type="leftwhite" className={style.arrow__icon} />
            </div>
            <div className={style.arrow} onClick={this.nextSlide}>
              <Icon type="rightwhite" className={style.arrow__icon} />
            </div>
          </div>
          <div className={style.section__content}>
            <h3 className={style.section__title}>{header}</h3>
            <p className={style.section__text}>{description}</p>
            <div className={style.button__panel}>
              <Button buttonName={linkButton} url={link} type="outer-link"/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProjectsBanner;
